import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Trophy, Star } from 'lucide-react';
import { Section } from './Shared';
const REFLEXO_HREF = 'https://www.lumenakasha.com/cart/46722804678845:1';
const ACELERADOR_HREF = 'https://www.lumenakasha.com/cart/46787506733245:1';
type PlanId = 'acelerador' | 'base';
const plans: {
  id: PlanId;
  emoji: string;
  name: string;
  desc: string;
  ideal: string;
  oldPrice: string;
  price: string;
  href: string;
  recommended: boolean;
}[] = [{
  id: 'acelerador',
  emoji: '🏆',
  name: 'KIT REFLEXO-PRO + ACELERADOR',
  desc: 'Tomo + 3 Bonus + Acelerador completo',
  ideal: 'Ideal para: terapeutas que quieren llenar agenda',
  oldPrice: '$47.980',
  price: '$27.990 ARS',
  href: ACELERADOR_HREF,
  recommended: true
}, {
  id: 'base',
  emoji: '🦶',
  name: 'KIT REFLEXO-PRO',
  desc: 'Tomo principal + 3 Bonus',
  ideal: 'Ideal para: organización clínica básica',
  oldPrice: '$29.990',
  price: '$19.990 ARS',
  href: REFLEXO_HREF,
  recommended: false
}];
export const Pricing = () => {
  const [selected, setSelected] = useState<PlanId>('acelerador');
  const selectedPlan = plans.find(p => p.id === selected)!;
  return <Section id="pricing" className="bg-brand-surfaceLight/30 rounded-3xl my-12" data-id="element-354">
      <div className="text-center mb-10" data-id="element-355">
        <h2 className="text-2xl md:text-4xl font-serif font-bold" data-id="element-356">
          ELEGÍ TU <span className="rose-gradient-text" data-id="element-357">KIT</span>
        </h2>
      </div>

      <div className="max-w-2xl mx-auto space-y-4" data-id="element-358">
        {plans.map(plan => {
        const isSelected = selected === plan.id;
        return <motion.button key={plan.id} type="button" onClick={() => setSelected(plan.id)} whileTap={{
          scale: 0.99
        }} aria-pressed={isSelected} className={`w-full text-left rounded-2xl md:rounded-3xl p-4 md:p-6 border-2 transition-all duration-300 ${isSelected ? 'border-brand-rose bg-white shadow-[0_0_24px_rgba(212,115,140,0.25)]' : 'border-brand-pink/30 bg-white/60 hover:border-brand-pink/60'}`} data-id="element-359">
              <div className="flex items-start gap-3 md:gap-4" data-id="element-360">
                {/* Radio */}
                <div className="shrink-0 mt-1" data-id="element-361">
                  <div className={`w-5 h-5 md:w-6 md:h-6 rounded-full border-2 flex items-center justify-center transition-colors ${isSelected ? 'border-brand-rose' : 'border-brand-pink/40'}`} data-id="element-362">
                    {isSelected && <motion.div initial={{
                  scale: 0
                }} animate={{
                  scale: 1
                }} className="w-2.5 h-2.5 md:w-3 md:h-3 rounded-full bg-brand-rose" data-id="element-363" />}
                  </div>
                </div>

                {/* Content */}
                <div className="flex-1 min-w-0" data-id="element-364">
                  {plan.recommended && <div className="flex items-center gap-1.5 mb-1.5 text-brand-rose" data-id="element-365">
                      <Trophy className="w-4 h-4 fill-brand-rose" data-id="element-366" />
                      <Star className="w-3.5 h-3.5 fill-brand-rose" data-id="element-367" />
                      <span className="text-[10px] md:text-xs font-bold tracking-wider uppercase" data-id="element-368">
                        Más elegido
                      </span>
                    </div>}

                  <div className="flex flex-wrap items-baseline justify-between gap-x-3 gap-y-1" data-id="element-369">
                    <div className="min-w-0" data-id="element-370">
                      <h3 className="font-serif font-bold text-sm md:text-lg text-brand-text leading-tight" data-id="element-371">
                        <span className="mr-1.5" data-id="element-372">{plan.emoji}</span>
                        {plan.name}
                      </h3>
                      <p className="text-xs md:text-sm text-brand-text/70 mt-1" data-id="element-373">
                        {plan.desc}
                      </p>
                      <p className="text-[11px] md:text-xs text-brand-rose font-medium mt-1.5" data-id="element-374">
                        {plan.ideal}
                      </p>
                    </div>

                    <div className="text-right shrink-0" data-id="element-375">
                      <p className="text-xs md:text-sm text-brand-text/40 line-through leading-none" data-id="element-376">
                        {plan.oldPrice}
                      </p>
                      <p className={`font-serif font-bold text-lg md:text-2xl leading-tight mt-1 ${isSelected ? 'text-brand-rose' : 'text-brand-text'}`} data-id="element-377">
                        {plan.price}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </motion.button>;
      })}

        {/* Single CTA */}
        <motion.a href={selectedPlan.href} animate={{
        scale: [1, 1.025, 1],
        y: [0, -2, 0]
      }} transition={{
        duration: 2.4,
        ease: 'easeInOut',
        repeat: Infinity
      }} whileHover={{
        scale: 1.04,
        y: -3,
        transition: {
          duration: 0.25
        }
      }} whileTap={{
        scale: 0.98
      }} className="mt-6 w-full inline-flex items-center justify-center px-6 py-4 md:py-5 text-sm md:text-lg font-bold text-white rose-gradient-bg rounded-full animate-glow-pulse relative overflow-hidden cta-shimmer" data-id="element-378">
          <span className="relative z-10" data-id="element-379">
            → QUIERO EL{' '}
            {selectedPlan.id === 'acelerador' ? 'KIT + ACELERADOR' : 'KIT REFLEXO-PRO'}
          </span>
        </motion.a>

        <p className="text-center text-xs md:text-sm text-brand-text/60 pt-2" data-id="element-380">
          🛡️ Garantía 7 días · 📥 Descarga inmediata · 🔒 Pago seguro
        </p>
      </div>
    </Section>;
};